export default __webpack_public_path__ + "static/media/hero-video-mobile-en.5400cd45.webm";